package com.swetdot.swetgram.cache

import kotlin.Long
import kotlin.String

public data class CachedDailyTasks(
  public val cacheKey: String,
  public val tasksJson: String,
  public val fetchedAt: Long,
)
